import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

// Importa los componentes de layout y secciones
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';
import ScrollLogo from '../homecomponents/ScrollLogo';
import Product from '../homecomponents/Product';
import Soluciones from '../homecomponents/Soluciones';
import Recursos from '../homecomponents/Recursos';

// URL del formulario de HubSpot (mismo que en PageHeader)
const HUBSPOT_FORM_URL =
  'https://tdgrm.share.hsforms.com/2o1NiMr-WRiWEniTAEpv4KQ';

function HomePage() {
  // Estado de idioma
  const [language, setLanguage] = useState(
    () =>
      (typeof window !== 'undefined' && localStorage.getItem('language')) ||
      'es'
  );

  // Persistencia en localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', language);
    }
  }, [language]);

  // Detecta si el navegador está en inglés
  const isEnglish =
    typeof navigator !== 'undefined' && navigator.language.startsWith('en');
  const buttonText = isEnglish ? 'Book Demo' : 'Reservar Demo';

  // Al hacer click en el botón, abre HubSpot en nueva pestaña
  const handleDemoClick = () => {
    if (typeof window !== 'undefined') {
      window.open(HUBSPOT_FORM_URL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />

      {/* HEADER con botón único de demo */}
      <header style={styles.header}>
        <p style={styles.title}>
          {language === 'es'
            ? 'Be there for your team'
            : 'Be there for your team'}
        </p>
        <h1 style={styles.subtitle}>
          {language === 'es'
            ? 'Potencia a tu equipo y destaca como manager con herramientas de IA que impulsan el rendimiento.'
            : 'Empower your team and stand out as a manager with AI tools that boost performance.'}
        </h1>

        {/* Botón personalizado */}
        <button onClick={handleDemoClick} style={styles.demoButton}>
          <FontAwesomeIcon
            icon={faWandMagicSparkles}
            style={{ marginRight: 8 }}
          />
          {buttonText}
        </button>
      </header>

      {/* SECCIÓN PRINCIPAL (claims) */}
      <section style={styles.claimSection}>
        <p style={styles.brandSectionTitle}>
          {language === 'es'
            ? 'Elegido por profesionales de:'
            : 'Trusted by professionals from:'}
        </p>
        <h2 style={styles.brandSectionSubtitle}>
          {language === 'es'
            ? 'las empresas más influyentes confían en nuestra herramienta para su desarrollo.'
            : 'top companies that count on our tool to drive their growth.'}
        </h2>
        <ScrollLogo />
      </section>

      {/* Secciones de producto, soluciones, recursos, servicios y precios */}
      <section id="product">
        <Product language={language} />
      </section>
      <section id="solutions">
        <Soluciones language={language} />
      </section>
      <section id="resources">
        <Recursos language={language} />
      </section>

      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  header: {
    backgroundColor: '#FF2300',
    textAlign: 'center',
    padding: '150px 20px',
    color: '#ffffff',
    position: 'relative',
  },
  title: {
    fontSize: 'clamp(40px, 10vw, 100px)',
    margin: '0 0 5px 0',
    fontWeight: 700,
    fontFamily: "'Helvetica Neue'",
  },
  subtitle: {
    fontSize: 'clamp(15px, 2vw, 20px)',
    margin: '0 0 45px 0',
    fontWeight: 400,
    fontFamily: "'Helvetica Neue'",
  },
  demoButton: {
    backgroundColor: '#ffffff',
    color: '#FF2300',
    padding: '12px 32px',
    border: 'none',
    borderRadius: '50px',
    fontWeight: 700,
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    fontSize: '16px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
  },
  claimSection: {
    padding: '30px 20px',
    textAlign: 'center',
    borderBottom: '1px solid #ddd',
  },
  brandSectionTitle: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#ff2300',
    marginBottom: '10px',
  },
  brandSectionSubtitle: {
    fontSize: '18px',
    color: '#555',
    fontWeight: 400,
    marginBottom: '30px',
  },
};

export default HomePage;
